import http from '@/core/http';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import {
  PostWebV1CertificateInfoPageApiReq,
  PostWebV1CertificateInfoPageApiRes,
  PostWebV1CertificateInfoApiReq,
  GetWebV1CertificateLogCidApiResItem,
} from './index.d';

/**
 * 证书管理 — 分页列表
 * @see https://yapi.baibu.la/project/996/interface/api/73136
 *
 * @请求方法: POST
 * @请求地址: /manage-app/web/v1/certificate-info/page
 * @更新时间: 2021-04-26 11:05:50
 */
export const postWebV1CertificateInfoPageApi = (data: PostWebV1CertificateInfoPageApiReq) => {
  return http.post<PostWebV1CertificateInfoPageApiRes>({
    url: '/manage-app/web/v1/certificate-info/page',
    data,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 证书管理 — 添加
 * @see https://yapi.baibu.la/project/996/interface/api/73130
 *
 * @请求方法: POST
 * @请求地址: /manage-app/web/v1/certificate-info
 * @更新时间: 2021-04-26 11:05:49
 */
export const postWebV1CertificateInfoApi = (data: PostWebV1CertificateInfoApiReq) => {
  return http.post({
    url: '/manage-app/web/v1/certificate-info',
    data,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 证书管理 — 编辑
 * @see https://yapi.baibu.la/project/996/interface/api/73130
 *
 * @请求方法: POST
 * @请求地址: /manage-app/web/v1/certificate-info
 * @更新时间: 2021-04-26 11:05:49
 */
export const putWebV1CertificateInfoApi = (data: PostWebV1CertificateInfoApiReq) => {
  return http.put({
    url: '/manage-app/web/v1/certificate-info',
    data,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 证书管理 - 终止
 * @see https://yapi.baibu.la/project/996/interface/api/73142
 *
 * @请求方法: POST
 * @请求地址: /manage-app/web/v1/certificate-info/updateEnable
 * @更新时间: 2021-04-26 11:23:40
 */
export const postWebV1CertificateInfoUpdateEnableApi = (data: {
  id: string;
  remark: string;
}) => {
  return http.post({
    url: '/manage-app/web/v1/certificate-info/updateEnable',
    data,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 通过证书id查看日志
 * @see https://yapi.baibu.la/project/996/interface/api/73312
 *
 * @请求方法: GET
 * @请求地址: /manage-app/web/v1/certificate-Log/{cid}
 * @更新时间: 2021-04-27 15:57:02
 */
export const getWebV1CertificateLogCidApi = (cid: string) => {
  return http.get<GetWebV1CertificateLogCidApiResItem[]>({
    url: `/manage-app/web/v1/certificate-Log/${cid}`,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
